import React, { createContext, useEffect, useState } from "react";
import { ThemeProvider } from "styled-components";
import axios from "axios";
import theme from "@styles/theme";

const initialState = {};

const PageContext = createContext(initialState);

const PageProvider = ({ children, location, locale }) => {
  const [id, setId] = useState("");
  const [countryCode, setCountryCode] = useState(
    typeof window !== "undefined" ? localStorage.getItem("countryCode") : null
  );

  useEffect(() => {
    if (!countryCode) {
      axios.get("https://ipapi.co/json/").then(res => {
        const { country_code } = res.data;

        localStorage.setItem("countryCode", country_code);

        setCountryCode(country_code);
      });
    }
  }, [countryCode]);

  return (
    <PageContext.Provider
      value={{
        id,
        setId,
        countryCode,
        location,
        locale
      }}
    >
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </PageContext.Provider>
  );
};

export default PageContext;

export { PageProvider };
